import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, tap } from 'rxjs';
import { LoginRequest } from '../../../models/requests/loginRequest';
import { LoginResult } from 'src/app/models/results/loginResult';
import { environment } from 'src/environments/environment';
import { PortalLoggedinUsers } from 'src/app/shared/services/portal-loggedin-users.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { RoutesList } from 'src/app/models/enums/RoutesList';
import { LocalizationService } from '../localization.service';
import { DataService } from '../data.service';
import { RouterService } from '../router.service';
import { SearchService } from '../search.service';
import { PortalLogOutExitCode } from 'src/app/models/enums/logOutExitCode';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public tokenKey: string = 'token';
  public dbUserLoginIdKey: string = 'dbUserLoginId';
  public static isPersonalizationPopupOpenedKey: string = "isPersonalizationPopupOpened";
  private _authStatus = new Subject<boolean>();
  public authStatus = this._authStatus.asObservable();

  constructor(
    protected http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private searchService: SearchService,
    private portalLoggedinUsers: PortalLoggedinUsers,
    private dataService: DataService,
    private routerService: RouterService,
  ) {}
  isAuthenticated(): boolean {
    return this.getToken() !== null;
  }
  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }
  init(): void {
    if (this.isAuthenticated()) {
      this.setAuthStatus(true);
    }
  }
  login(loginRequest: LoginRequest): Observable<LoginResult> {
    var url = environment.apiUrl + '/Portal/Account/StandardLogin';
    return this.http.post<LoginResult>(url, loginRequest).pipe(
      tap((loginResult) => {
        if (loginResult.succeed && loginResult.token) {
          localStorage.setItem(this.tokenKey, loginResult.token);
          //Saveing the loginId of the Portal.LoginUsers table
          if(Number(loginResult.loginId) > 0)
            localStorage.setItem(this.dbUserLoginIdKey, loginResult.loginId);
          this.setAuthStatus(true);
        }
      })
    );
  }
  logout(exitCode: PortalLogOutExitCode, noRedirect:boolean = false) {
    this.searchService.setOpen(false);
    let preview = this.document
      .querySelector('app-root')
      ?.getAttribute('preview');

    this.portalLoggedinUsers.setLogOutDateInDB(exitCode);
    this.portalLoggedinUsers.stopUpdateLastSeenDateInterval(); // Ensure interval stops

    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.dbUserLoginIdKey);
    localStorage.removeItem(AuthService.isPersonalizationPopupOpenedKey);
    this.setAuthStatus(false);
    if(!noRedirect) this.router.navigate([LocalizationService.getRoute(RoutesList.LoginPage)]);

    if (preview) return;
  }
  changeSessionView(sesionEnum: any) {
    var url =
      environment.apiUrl + '/Portal/Menu-Api/setSessionViewTypeForPortalMenu';
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      pageUrl: this.routerService.getCurrentComponentRoute(),
      sessionTypeEnum: sesionEnum,
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (result) => {
        window.location.reload();
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  //private method
  private setAuthStatus(isAuthenticated: boolean): void {
    this._authStatus.next(isAuthenticated);
  }
}
